import { useWidget } from '@telescope/cassini-hooks';
import { Container, Heading } from '@telescope/cassini-ui';
import { Link, Text } from 'components';
import { Open } from 'generated-types/widget';
import { useParams } from 'react-router-dom';
import { ErrorType } from 'types';

interface ErrorPageProps {
  /**
   * If provided, used as key to for looking up error copy in widget. If omitted, the page will default to checking the url params for an error type
   */
  errorType?: ErrorType;
  /**
   * Additional content to be displayed
   */
  children?: React.ReactNode;
}

export const ErrorPage = ({ children, errorType }: ErrorPageProps) => {
  const { errorType: errorTypeFromUrlParam } = useParams();
  const {
    data: { content },
  } = useWidget<Open>({
    select: (data) =>
      data.widget.globalViews.errors.content[(errorType || (errorTypeFromUrlParam as ErrorType)) ?? ErrorType.GENERIC],
  });

  return (
    <>
      <Container as="section" className="ErrorPage__root" py={14}>
        <Heading className="ErrorPage__headline" textAlign="center" as="h1" size="lg" mb={2}>
          {content.headline}
        </Heading>
        <Text className="ErrorPage__description" textAlign="center" mb={4} allowMarkdown>
          {content.description}
        </Text>
        <Link href={content.link?.url}>{content.link?.text}</Link>
        {children}
      </Container>
    </>
  );
};
